import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Skeleton,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ErrorView from "../ErrorView/ErrorView";
import classes from "./TwoDGrid.module.css";

const styles = {
  columnHeader: {
    backgroundColor: "#4fd1c5",
    padding: "10px",
    textAlign: "center",
    borderBottom: "2px solid rgb(206, 205, 192)",
  },
  rowHeader: {
    // backgroundColor: "#eff4f8",
    padding: "10px",
    fontWeight: "bold",
    borderRadius: "5px",
    textAlign: "center",
    color: "black",
    writingMode: "vertical-rl", // Rotate text
    transform: "rotate(180deg)", // Correct orientation
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // height: "100%",
  },
  card: { padding: "2px" },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  gridContainer: { margin: 0, width: "100%", alignItems: "center" },
  sectionContainer: { margin: "5px 0px" },
};

const rowHeadersColor = ["#FFCE6E", "#C7F0EC", "#FEE7E6", "#CEB4FF"];

function LoadingSkeletion() {
  return (
    <div className="p-3">
      <div className="d-flex">
        <p style={{ width: "38px", height: "25px" }}></p>
        {Array(3)
          .fill(0)
          .map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={450}
              height={40}
              className="mx-1"
            />
          ))}
      </div>

      {Array(4)
        .fill(0)
        .map((_, rowIndex) => (
          <div key={rowIndex} className="d-flex align-items-center my-2">
            <Skeleton
              variant="rectangular"
              width={30}
              height={300}
              className="me-2"
            />

            {Array(3)
              .fill(0)
              .map((_, colIndex) => (
                <div key={colIndex} className="d-flex flex-column mx-1">
                  {Array(4)
                    .fill(0)
                    .map((_, subIndex) => (
                      <Skeleton
                        key={subIndex}
                        variant="rectangular"
                        width={450}
                        height={65}
                        className="my-1"
                      />
                    ))}
                </div>
              ))}
          </div>
        ))}
    </div>
  );
}

const GridComponent = ({
  getBuyingJourneyPrompts,
  error,
  inputData,
  loading,
  key,
  title,
}) => {
  const headersX = Array.from(
    new Set(
      Object.values(inputData)
        .flat()
        .map((item) => item.type)
    )
  );
  const headersY = Object.keys(inputData);

  return (
    <Card sx={{ m: 3, boxShadow: 3, borderRadius: 4 }}>
      <p></p>
      <Typography variant="h6" align="center" gutterBottom>
        {title}
      </Typography>
      <Grid container spacing={1} sx={styles.gridContainer}>
        <Grid item xs={12} container spacing={1} alignItems="center">
          <Grid item xs={0.5} />
          {headersX.map((header, index) => (
            <Grid item xs key={index}>
              <Typography variant="h6" sx={styles.columnHeader}>
                {header}
              </Typography>
            </Grid>
          ))}
        </Grid>

        {headersY.map((yHeader, rowIndex) => (
          <>
            <Grid
              item
              xs={12}
              container
              spacing={1}
              sx={styles.sectionContainer}
              key={rowIndex}
            >
              <Typography
                variant="h6"
                sx={{
                  ...styles.rowHeader,
                  borderLeft: `solid 7px ${rowHeadersColor[rowIndex]}`,
                }}
              >
                {yHeader}
              </Typography>

              {headersX.map((xHeader, colIndex) => {
                const questions = inputData[yHeader]
                  .filter((item) => item.type === xHeader)
                  .map((item) => item.qst);
                return (
                  <Grid item xs key={colIndex}>
                    <Box display="flex" flexDirection="column" gap={1}>
                      {questions.length > 0 ? (
                        questions.map((q, idx) => (
                          <Card key={idx} sx={styles.card}>
                            <CardContent sx={styles.cardContent}>
                              <Typography>{q}</Typography>
                              <InfoIcon
                                fontSize="small"
                                sx={{ marginTop: "5px", color: "#007bff" }}
                              />
                            </CardContent>
                          </Card>
                        ))
                      ) : (
                        <Card sx={styles.card}>
                          <CardContent sx={styles.cardContent}>
                            <Typography variant="body2" color="textSecondary">
                              No Prompts
                            </Typography>
                          </CardContent>
                        </Card>
                      )}
                    </Box>
                  </Grid>
                );
              })}
            </Grid>
            <br />
          </>
        ))}
      </Grid>

      {error && (
        <div className={classes.error}>
          <ErrorView
            title={"Error fetching Data"}
            message={error}
            retry
            onRetry={() => getBuyingJourneyPrompts(key)}
          />
        </div>
      )}
      {loading && !error && <LoadingSkeletion />}
    </Card>
  );
};

export default GridComponent;
